import { pxToRem } from "@deltek/specification-client/core/Utilities/unitUtils"
import { Button, DialogActions, makeStyles, Theme } from "@material-ui/core"
import React from "react"

const useStyles = makeStyles((theme: Theme) => ({
    dialogActions: {
        margin: theme.spacing(1, 0, -1),
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        justifyContent: 'flex-end',
        padding: theme.spacing(1, 0)
    },
    cancelButton: {
        backgroundColor: 'transparent',
        marginRight: theme.spacing(1),
        color: '#1899D4',
        fontSize: pxToRem(18),
    },
    continueButton: {
        color: '#1899D4',
        fontSize: pxToRem(18),
        '&:disabled': {
            color: '#999999',
        },
        marginRight: theme.spacing(-1)
    },
}))

/**
 * Props for the ManageUnmappedDialogActions component
 */
interface ManageUnmappedDialogActionsProps {
    /** Callback when the cancel button is clicked */
    onCancel: () => void
    /** Callback when the continue button is clicked */
    onContinue: () => void
    /** Whether the continue button should be disabled */
    disabled: boolean
}

/**
 * Reusable dialog actions component for manage unmapped product dialogs.
 * 
 * Provides consistent Cancel and "Save and Continue" buttons with proper styling
 * and disabled state handling across the manage unmapped product workflow.
 * 
 * @param props - The component props
 * @returns The ManageUnmappedDialogActions component
 */
const ManageUnmappedDialogActions = ({ onCancel, onContinue, disabled }: ManageUnmappedDialogActionsProps) => {

    const classes = useStyles()

    return <DialogActions className={classes.dialogActions}>
        <Button
            color='secondary'
            onClick={onCancel}
            className={classes.cancelButton}
            variant="text"
        >
            Cancel
        </Button>
        <Button
            color="primary"
            onClick={onContinue}
            className={classes.continueButton}
            disabled={disabled}
            variant="text"
        >
            Save and Continue
        </Button>
    </DialogActions>
}

export default ManageUnmappedDialogActions